import React, { useMemo } from 'react';
import classNames from 'classnames';
import { restorePreviousValue, updatePaymentValue } from 'components/customMobileInput/action';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { shallowEqual } from 'react-redux';
import { MovimentiTipoScommessaEnum } from 'types/swagger';
import { selectBonusFromType, selectIsBonusGoldVisible, selectIsSistemaByTicket } from 'features/carrello/carrelloSelectors';
import { PaymentMethodEnum, selectedImportoType } from 'features/carrello/carrelloSlice';
import styles from './CarrelloBonusButtons.module.scss';

type CarrelloBonusButtonsProps = {
  verticalLayout?: boolean;
  hasPadding?: boolean;
};

export const CarrelloBonusButtons = ({ verticalLayout, hasPadding }: CarrelloBonusButtonsProps) => {
  const dispatch = useAppDispatch();

  const cartType = useTypedSelector((state) => state.carrello.tipo);
  const isGoldVisible = useTypedSelector(selectIsBonusGoldVisible);
  const { bonus, saldoReal } = useTypedSelector(selectBonusFromType);
  const isSistema = useTypedSelector((state) => selectIsSistemaByTicket(state, cartType));
  const importoType = useTypedSelector((state) => state.carrello.importoType, shallowEqual);

  const [paymentMethodCashLabel, paymentMethodGoldLabel] = useGetLabelsByKeys([
    'payment-method-cash',
    'payment-method-gold',
  ]);

  const onPaymentTypeButtonClick = (paymentMethod: PaymentMethodEnum) => {
    if (paymentMethod === PaymentMethodEnum.Cash && isBonusCashDisabled) return;
    const selectedPaymentMethod = importoType === paymentMethod ? PaymentMethodEnum.None : paymentMethod;

    dispatch(
      selectedPaymentMethod === PaymentMethodEnum.None
        ? restorePreviousValue()
        : updatePaymentValue(selectedPaymentMethod)
    );
    dispatch(selectedImportoType(selectedPaymentMethod));
  };

  const paymentsType = useMemo(() => {
    if (isSistema) return [];

    if (isGoldVisible) {
      return [PaymentMethodEnum.Cash, PaymentMethodEnum.Gold];
    }
    return [PaymentMethodEnum.Cash];
  }, [isGoldVisible, isSistema]);

  const isBonusCashDisabled = useMemo(() => {
    const threshold = cartType === MovimentiTipoScommessaEnum.Ippica ? 2 : 1;
    return bonus + saldoReal < threshold;
  }, [bonus, cartType, saldoReal]);

  return (
    <div
      className={classNames(styles.buttonsContainer, {
        [styles.vertical]: verticalLayout,
        [styles.padding]: hasPadding,
      })}
    >
      {paymentsType.map((paymentMethod, index) => (
        <div className={styles.item} key={index}>
          <button
            className={classNames(styles.paymentMethod, {
              [styles.active]: importoType === paymentMethod,
              [styles.disabled]: paymentMethod === PaymentMethodEnum.Cash && isBonusCashDisabled,
            })}
            onClick={() => onPaymentTypeButtonClick(paymentMethod)}
          >
            {paymentMethod === PaymentMethodEnum.Cash ? paymentMethodCashLabel : paymentMethodGoldLabel}
          </button>
        </div>
      ))}
    </div>
  );
};

export default CarrelloBonusButtons;